import {Component, OnInit} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {NextOffersSectionStateService} from '../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';
import {Offer} from '../../../../core/models/offer/offer.model';
import {isCarOne, isMobile} from '../../../../core/utils/utils';
import {FiltersService} from '../../../services/filters.service';
import {OfferRecommendationsService} from '../../../../core/services/impl/offer-recommendations.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ApplicationContextService} from '../../../../core/services/impl/configuration/application-context.service';
import {TestingPresetsService} from '../../../services/debugging/testing-presets.service';
import {TestingPresetKey} from '../../../../core/enums/debugging/testing-preset-key.enum';

@Component({
    selector: 'app-next-offers-section',
    templateUrl: './next-offers-section.component.html',
    styleUrls: []
})
export class NextOffersSectionComponent extends SectionBase implements OnInit {

    hiddenOffersVisible: boolean = isCarOne();
    leftContentVisible: boolean = !isCarOne();
    controlPanelVisible: boolean = !isCarOne();
    tableViewAllowed: boolean = !isCarOne();
    readonly translationsContainer = 'OFFER_SECTION';
    private readonly VISIBLE_OFFERS_AMOUNT: number = 8;

    get valid(): boolean {
        return !!this.offersSectionStateService.selectedOffer && !!this.offersSectionStateService.selectedOffer.id;
    }

    get offers(): Offer[] {
        return this.offersSectionStateService.offers ? this.offersSectionStateService.offers : [];
    }

    get offersForExpandableMode(): Offer[] {
        return this.hiddenOffersVisible ? this.offers : this.offers.slice(0, this.VISIBLE_OFFERS_AMOUNT);
    }

    get recommendedOffers(): Offer[] {
        return this.offerRecommendationsService.activeRecommendations
            .map(recommendation => recommendation.offer)
            .filter(offer => isNotNullOrUndefined(offer));
    }

    get filtersVisible(): boolean {
        return !isMobile();
    }

    get noOffersForFilters(): boolean {
        if (TestingPresetsService.isPresetActive(TestingPresetKey.REJECT_ALL_OFFERS)) {
            return true;
        }
        return this.offersSectionStateService.rawOffers.length > 0 && this.offers.length === 0 && this.filtersService.filtersApplied;
    }

    get offersNumber(): number {
        return this.offers ? this.offers.length : 0;
    }

    get hiddenOffersExist(): boolean {
        return !this.hiddenOffersVisible && this.offersNumber > this.VISIBLE_OFFERS_AMOUNT;
    }

    get hiddenOffersAmount(): number {
        return this.hiddenOffersExist ? this.offersNumber - this.VISIBLE_OFFERS_AMOUNT : 0;
    }

    get headerWithTitleBadge(): boolean {
        return isNotNullOrUndefined(this.contextService.headerTitleBadge);
    }

    constructor(public offersSectionStateService: NextOffersSectionStateService,
                public offerRecommendationsService: OfferRecommendationsService,
                public filtersService: FiltersService,
                private contextService: ApplicationContextService) {
        super();
    }

    ngOnInit() {
        this.filtersService.initFilters();
    }

    createConfig(): void {
    }

    initBean(): void {
    }

    initControlsChanges(): void {
    }

    public submitSection(): void {
        // section hasn't form to submit
    }

    showHiddenOffers(): void {
        this.hiddenOffersVisible = true;
    }

}
